import HeroSection from "../components/Home-page-components/HeroSection";
import SolutionsSection from "../components/Home-page-components/SolutionsSection";
import MetricsSection from "../components/Home-page-components/MetricsSection";
import CapabilitiesSection from "../components/Home-page-components/CapabilitiesSection";
import MethodologySection from "../components/Home-page-components/MethodologySection";
import TestimonialsSection from "../components/Home-page-components/TestimonialsSection";
import VerticalsSection from "../components/Home-page-components/VerticalsSection";
import CTASection from "../components/Home-page-components/CTASection";
import Whychooseus from "../components/Home-page-components/WhyChooseUs";

const Home = () => {
  return (
    <div className="home-page">

      <HeroSection />

      <SolutionsSection />

      <MetricsSection />

      <CapabilitiesSection />

      <MethodologySection />

      <Whychooseus />

      <TestimonialsSection />

      <VerticalsSection />

      <CTASection />

    </div>
  );
};

export default Home;